import * as React from 'react';
import { FieldWrapper } from '@progress/kendo-react-form';
import {
    Input, MaskedTextBox, NumericTextBox,
    Checkbox, Switch, RadioGroup,
    Slider, SliderLabel, RangeSlider, TextArea
} from '@progress/kendo-react-inputs';
import { DatePicker, DateTimePicker } from '@progress/kendo-react-dateinputs';
import { Label, Error, Hint } from '@progress/kendo-react-labels';
import { DropDownList, AutoComplete, ComboBox } from '@progress/kendo-react-dropdowns';

export const FormInput = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, disabled, hint, type, optional, ...others } = fieldRenderProps;

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';

    return (
        <div className="row around-xs inputPair elementVisible"  >
            <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                <div className="box">{label}</div>
            </div><div className="col-xs-12 col-sm-7 col-md-7 col-lg-7" >
                <div className="box">
                    <FieldWrapper>
                        <div className={'k-form-field-wrap'}>

                            <Input
                                valid={valid}
                                type={type}
                                id={id}
                                disabled={disabled}
                                aria-describedby={`${hintId} ${errorId}`}
                                {...others}
                            />
                            {
                                showHint &&
                                <Hint id={hintId}>{hint}</Hint>
                            }
                            {
                                showValidationMessage &&
                                <Error id={errorId} className={'k-required'}>{validationMessage}</Error>
                            }
                        </div>
                    </FieldWrapper>

                </div>
            </div>
        </div>
    );
};


export const FormInputTEST = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, disabled, hint, type, optional, wrapperStyle, ...others } = fieldRenderProps;
    const labelId = label ? `${id}_label` : '';
    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';
    const editorRef = React.useRef(null);

    return (
        <div className="row around-xs inputPair elementVisible"  >
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <div className="box">{label}</div>
                <div className="box">
                    <FieldWrapper>
                        <div className={'k-form-field-wrap'}>
                            <Input
                                valid={valid}
                                type={type}
                                id={id}
                                disabled={disabled}
                                aria-describedby={`${hintId} ${errorId}`}
                                {...others}
                            />
                            {
                                showHint &&
                                <Hint id={hintId}>{hint}</Hint>
                            }
                            {
                                showValidationMessage &&
                                <Error id={errorId} className={'k-required'}>{validationMessage}</Error>
                            }
                        </div>
                    </FieldWrapper>

                </div>
            </div><div className="col-xs-12 col-sm-6 col-md-6 col-lg-6" >
                <div className="box">Loan Repayment Period</div>
                <div className="box">
                    <FieldWrapper style={wrapperStyle}>
                        <ComboBox
                            ariaLabelledBy={labelId}
                            aria-describedby={`${hintId} ${errorId}`}
                            ref={editorRef}
                            valid={valid}
                            id={id}
                            disabled={disabled}
                            {...others}
                        />
                        {
                            showHint &&
                            <Hint id={hintId}>{hint}</Hint>
                        }
                        {
                            showValidationMessage &&
                            <Error id={errorId}>{validationMessage}</Error>
                        }
                    </FieldWrapper>

                </div>
            </div>
        </div>
    );
};
export const FormInputTEST1 = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, disabled, hint, type, optional, wrapperStyle, ...others } = fieldRenderProps;
    const labelId = label ? `${id}_label` : '';
    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';
    const editorRef = React.useRef(null);

    return (
        <div className="row around-xs inputPair elementVisible"  >
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <div className="box">{label}</div>
                <FieldWrapper style={wrapperStyle}>
                    <ComboBox
                        ariaLabelledBy={labelId}
                        aria-describedby={`${hintId} ${errorId}`}
                        ref={editorRef}
                        valid={valid}
                        id={id}
                        disabled={disabled}
                        {...others}
                    />
                    {
                        showHint &&
                        <Hint id={hintId}>{hint}</Hint>
                    }
                    {
                        showValidationMessage &&
                        <Error id={errorId}>{validationMessage}</Error>
                    }
                </FieldWrapper>

            </div>
        </div>

    );
};






export const FormInputLC = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, disabled, hint, type, optional, ...others } = fieldRenderProps;
    const editorRef = React.useRef(null);
    const labelId = label ? `${id}_label` : '';
    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';

    return (
        <FieldWrapper>
            <div className="row around-xs inputPair elementVisible"  >
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div className="box"  >
                        <Label editorId={id} editorDisabled={disabled} optional={optional}>{"Loan Amount (S$)"}</Label>
                        <div className={'k-form-field-wrap'}>
                            <input style={{ width: "100%", padding: "7px" }}
                                valid={valid}
                                type={type}
                                id={id}
                                disabled={disabled}
                                aria-describedby={`${hintId} ${errorId}`}
                                {...others}
                            />
                            {
                                showHint &&
                                <Hint id={hintId}>{hint}</Hint>
                            }
                            {
                                showValidationMessage &&
                                <Error id={errorId}>{validationMessage}</Error>
                            }
                        </div>
                    </div>
                </div>

                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div className="box"  >

                        <Label editorId={id} editorDisabled={disabled} optional={optional}>{"Loan Amount (S$)"}</Label>

                        <ComboBox
                            ariaLabelledBy={labelId}
                            aria-describedby={`${hintId} ${errorId}`}
                            ref={editorRef}
                            valid={valid}
                            id={id}
                            disabled={disabled}
                            {...others}
                        />
                        {
                            showHint &&
                            <Hint id={hintId}>{hint}</Hint>
                        }
                        {
                            showValidationMessage &&
                            <Error id={errorId}>{validationMessage}</Error>
                        }
                    </div></div>
            </div>
        </FieldWrapper>
    );
};


export const FormComboBoxLC = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, disabled, hint, wrapperStyle, ...others } = fieldRenderProps;
    const editorRef = React.useRef(null);
    const labelId = label ? `${id}_label` : '';
    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';


    return (


        <div className="row around-xs inputPair elementVisible"  >
            <div className="col-xs-12 col-sm- col-md-4 col-lg-4">
                <div className="box">{label}</div>
            </div><div className="col-xs-12 col-sm-8 col-md-8 col-lg-8">
                <div className="box">
                    <FieldWrapper style={wrapperStyle}>
                        <ComboBox
                            ariaLabelledBy={labelId}
                            aria-describedby={`${hintId} ${errorId}`}
                            ref={editorRef}
                            valid={valid}
                            id={id}
                            disabled={disabled}
                            {...others}
                        />
                        {
                            showHint &&
                            <Hint id={hintId}>{hint}</Hint>
                        }
                        {
                            showValidationMessage &&
                            <Error id={errorId}>{validationMessage}</Error>
                        }
                    </FieldWrapper>

                </div>
            </div>
        </div>




    );
};


export const FormInputnolbl = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, disabled, hint, type, optional, ...others } = fieldRenderProps;

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';


    return (

        <div className="row around-xs inputPair elementVisible"  >
            <div className="col-xs-12 col-sm-8 col-md-8 col-lg-8" >
                <div className="box">
                    <FieldWrapper>
                        <div className={'k-form-field-wrap'}>

                            <Input
                                valid={valid}
                                type={type}
                                id={id}
                                max={11}
                                disabled={disabled}
                                aria-describedby={`${hintId} ${errorId}`}
                                {...others}
                            />
                            {
                                showHint &&
                                <Hint id={hintId}>{hint}</Hint>
                            }
                            {
                                showValidationMessage &&
                                <Error id={errorId} className={'k-required'}>{validationMessage}</Error>
                            }
                        </div>
                    </FieldWrapper>

                </div>
            </div>
        </div>
    );
};
export const FormReviewLabel = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, disabled, hint, type, optional, ...others } = fieldRenderProps;
    return (
        <div className="row around-xs inputPair elementVisible"  >
            <div className=" col-xs-12 col-sm-7 col-md-7 col-lg-7">
                <div className="box text-left">{id}</div>
            </div><div className=" col-xs-12 col-sm-5 col-md-5 col-lg-5">
                <strong className="box" style={{ wordBreak: "break-word" }}  >{label}</strong>
            </div>
        </div>
    );
};

export const FormRadioGroup = (fieldRenderProps) => {
    const { validationMessage, touched, id, label, valid, disabled, hint, visited, modified, ...others } = fieldRenderProps;
    const editorRef = React.useRef(null);

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';
    const labelId = label ? `${id}_label` : '';

    return (
        <FieldWrapper>
            <Label id={labelId} editorRef={editorRef} editorId={id} editorValid={valid} editorDisabled={disabled}>{label}</Label>
            <RadioGroup
                id={id}
                aria-describedby={`${hintId} ${errorId}`}
                ariaLabelledBy={labelId}
                valid={valid}
                disabled={disabled}
                ref={editorRef}
                {...others}
            />
            {
                showHint &&
                <Hint id={hintId}>{hint}</Hint>
            }
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </FieldWrapper>
    );
};



export const FormCheckbox = (fieldRenderProps) => {
    const { validationMessage, touched, id, valid, disabled, hint, optional, label, visited, modified, ...others } = fieldRenderProps;

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';

    return (
        <FieldWrapper>
            <Checkbox
                aria-describedby={`${hintId} ${errorId}`}
                label={label}
                labelOptional={optional}
                valid={valid}
                id={id}
                disabled={disabled}
                {...others}
            />
            {
                showHint &&
                <Hint id={hintId}>{hint}</Hint>
            }
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </FieldWrapper>
    );
};

export const FormSwitch = (fieldRenderProps) => {
    const { validationMessage, touched, label, optional, id, valid, disabled, hint, ...others } = fieldRenderProps;
    const editorRef = React.useRef(null);

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';
    const labelId = label ? `${id}_label` : '';

    return (
        <FieldWrapper>
            <Label
                id={labelId}
                editorRef={editorRef}
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
                optional={optional}
            >
                {label}
            </Label>
            <Switch
                ref={editorRef}
                ariaLabelledBy={labelId}
                aria-describedby={`${hintId} ${errorId}`}
                valid={valid}
                id={id}
                disabled={disabled}
                {...others}
            />
            {
                showHint &&
                <Hint id={hintId}>{hint}</Hint>
            }
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </FieldWrapper>
    );
};

export const FormMaskedTextBox = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, hint, optional, ...others } = fieldRenderProps;

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';

    return (
        <FieldWrapper>

            <div className="row around-xs inputPair elementVisible"  >
                <div className="col-xs-12 col-sm-8 col-md-8 col-lg-8">
                    <div className="box">
                        <FieldWrapper>
                            <div className={'k-form-field-wrap'}>
                                <MaskedTextBox
                                    aria-describedby={`${hintId} ${errorId}`}
                                    valid={valid}
                                    id={id}
                                    {...others}
                                />
                                {
                                    showHint &&
                                    <Hint id={hintId}>{hint}</Hint>
                                }
                                {
                                    showValidationMessage &&
                                    <Error id={errorId} className={'k-required'}>{validationMessage}</Error>
                                }
                            </div>
                        </FieldWrapper>

                    </div>
                </div>
            </div>
        </FieldWrapper>
    );
};

export const FormTextArea = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, hint, disabled, optional, ...others } = fieldRenderProps;

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';

    return (
        <FieldWrapper>
            <Label editorId={id} editorValid={valid} optional={optional}>{label}</Label>
            <TextArea
                valid={valid}
                id={id}
                disabled={disabled}
                aria-describedby={`${hintId} ${errorId}`}
                {...others}
            />
            {
                showHint &&
                <Hint id={hintId}>{hint}</Hint>
            }
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </FieldWrapper>
    );
};

export const FormSlider = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, disabled, hint, data, ...others } = fieldRenderProps;

    const editorRef = React.useRef(null);
    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';
    const labelId = label ? `${id}_label` : '';

    return (
        <FieldWrapper>
            <Label
                id={labelId}
                editorRef={editorRef}
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
            >
                {label}
            </Label>
            <Slider
                ariaLabelledBy={labelId}
                aria-describedby={`${hintId} ${errorId}`}
                ref={editorRef}
                valid={valid}
                id={id}
                disabled={disabled}
                {...others}
            >
                {
                    data.map(value => (
                        <SliderLabel
                            title={value}
                            key={value}
                            position={value}
                        >
                            {value.toString()}
                        </SliderLabel>
                    ))
                }
            </Slider>
            {
                showHint &&
                <Hint id={hintId}>{hint}</Hint>
            }
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </FieldWrapper>
    );
};

export const FormRangeSlider = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, hint, disabled, data, ...others } = fieldRenderProps;

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';

    return (
        <FieldWrapper>
            <Label editorId={id} editorValid={valid}>{label}</Label>
            <RangeSlider
                valid={valid}
                id={id}
                disabled={disabled}
                aria-describedby={`${hintId} ${errorId}`}
                {...others}
            >{
                    data.map(value => {
                        return (
                            <SliderLabel
                                key={value}
                                position={value}
                            >
                                {value.toString()}
                            </SliderLabel>
                        )
                    })
                }
            </RangeSlider>
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </FieldWrapper>
    );
};

export const FormDropDownList = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, disabled, hint, wrapperStyle, ...others } = fieldRenderProps;
    const editorRef = React.useRef(null);

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';
    const labelId = label ? `${id}_label` : '';

    return (
        <FieldWrapper style={wrapperStyle}>
            <Label
                id={labelId}
                editorRef={editorRef}
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
            >
                {label}
            </Label>
            <DropDownList
                ariaLabelledBy={labelId}
                aria-describedby={`${hintId} ${errorId}`}
                ref={editorRef}
                valid={valid}
                id={id}
                disabled={disabled}
                {...others}
            />
            {
                showHint &&
                <Hint id={hintId}>{hint}</Hint>
            }
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </FieldWrapper>
    );
};

export const FormAutoComplete = fieldRenderProps => {
    const {
        validationMessage,
        touched,
        label,
        id,
        valid,
        disabled,
        hint,
        wrapperStyle,
        ...others
    } = fieldRenderProps;
    const editorRef = React.useRef(null);

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : "";
    const errorId = showValidationMessage ? `${id}_error` : "";
    const labelId = label ? `${id}_label` : "";

    return (
        <FieldWrapper style={wrapperStyle}>
            <Label
                id={labelId}
                editorRef={editorRef}
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
            >
                {label}
            </Label>
            <AutoComplete
                ariaLabelledBy={labelId}
                aria-describedby={`${hintId} ${errorId}`}
                ref={editorRef}
                valid={valid}
                id={id}
                disabled={disabled}
                {...others}
            />
            {showHint && <Hint id={hintId}>{hint}</Hint>}
            {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
        </FieldWrapper>
    );
};

export const FormNumericTextBox = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, disabled, hint, ...others } = fieldRenderProps;

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';

    return (
        <div className="row around-xs inputPair elementVisible"  >
            <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                <div className="box">{label}</div>
            </div><div className="col-xs-12 col-sm-7 col-md-7 col-lg-7" >
                <div className="box">
                    <FieldWrapper>
                        <div className={'k-form-field-wrap'}>

                            <NumericTextBox
                                ariaDescribedBy={`${hintId} ${errorId}`}
                                valid={valid}
                                id={id}
                                disabled={disabled}
                                {...others}
                            />
                            {
                                showHint &&
                                <Hint id={hintId}>{hint}</Hint>
                            }
                            {
                                showValidationMessage &&
                                <Error id={errorId} className={'k-required'}>{validationMessage}</Error>
                            }
                        </div>
                    </FieldWrapper>

                </div>
            </div>
        </div>





    );
};
export const FormComboBox = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, disabled, hint, wrapperStyle, ...others } = fieldRenderProps;
    const editorRef = React.useRef(null);

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';
    const labelId = label ? `${id}_label` : '';

    return (


        <div className="row around-xs inputPair elementVisible"  >
            <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                <div className="box">{label}</div>
            </div><div className="col-xs-12 col-sm-7 col-md-7 col-lg-7">
                <div className="box">
                    <FieldWrapper style={wrapperStyle}>
                        <ComboBox className='k-header'
                            ariaLabelledBy={labelId}
                            aria-describedby={`${hintId} ${errorId}`}
                            ref={editorRef}
                            valid={valid}
                            id={id}
                            disabled={disabled}
                            {...others}
                        />
                        {
                            showHint &&
                            <Hint id={hintId}>{hint}</Hint>
                        }
                        {
                            showValidationMessage &&
                            <Error id={errorId}>{validationMessage}</Error>
                        }
                    </FieldWrapper>

                </div>
            </div>
        </div>




    );
};

export const FormDatePicker = (fieldRenderProps) => {
    const {
        validationMessage, touched, label, id, valid,
        disabled, hint, wrapperStyle, hintDirection, ...others
    } = fieldRenderProps;

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';
    const labelId = label ? `${id}_label` : '';

    return (
        <FieldWrapper style={wrapperStyle}>
            <Label id={labelId} editorId={id} editorValid={valid} editorDisabled={disabled}>
                {label}
            </Label>
            <div className={'k-form-field-wrap'}>
                <DatePicker
                    ariaLabelledBy={labelId}
                    aria-describedby={`${hintId} ${errorId}`}
                    valid={valid}
                    id={id}
                    disabled={disabled}
                    {...others}
                />
                {
                    showHint &&
                    <Hint id={hintId} direction={hintDirection}>{hint}</Hint>
                }
                {
                    showValidationMessage &&
                    <Error id={errorId}>{validationMessage}</Error>
                }
            </div>
        </FieldWrapper>
    );
};

export const FormDateTimePicker = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, disabled, hint, wrapperStyle, ...others } = fieldRenderProps;

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';
    const labelId = label ? `${id}_label` : '';

    return (
        <FieldWrapper style={wrapperStyle}>
            <Label id={labelId} editorId={id} editorValid={valid} editorDisabled={disabled}>
                {label}
            </Label>
            <DateTimePicker
                ariaLabelledBy={labelId}
                aria-describedby={`${hintId} ${errorId}`}
                valid={valid}
                id={id}
                disabled={disabled}
                {...others}
            />
            {
                showHint &&
                <Hint id={hintId}>{hint}</Hint>
            }
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </FieldWrapper>
    );
};

